import React, { createContext, useContext, useState, useEffect } from 'react';

const CurrencyContext = createContext();

export const exchangeRates = {
  AUD: 1,
  USD: 0.67,
  GBP: 0.53,
  EUR: 0.62,
  JPY: 98.5
};

export function CurrencyProvider({ children }) {
  const [currency, setCurrency] = useState(() => localStorage.getItem('currency') || 'AUD');

  useEffect(() => {
    localStorage.setItem('currency', currency);
  }, [currency]);

  const convertPrice = (price) => {
    if (typeof price !== 'number') return price;
    const rate = exchangeRates[currency] || 1;
    return (price * rate).toFixed(2);
  };

  const getCurrencySymbol = () => {
    switch (currency) {
      case 'AUD': return '$';
      case 'USD': return '$';
      case 'GBP': return '£';
      case 'EUR': return '€';
      case 'JPY': return '¥';
      default: return '$';
    }
  };

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency, exchangeRates, convertPrice, getCurrencySymbol }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
